module.exports = __webpack_public_path__ + "img/contrat-check-green.72fdcbb9.svg";